<script>
import Jobs from "@/components/jobs/Jobs.vue";
import SearchJob from "@/components/jobs/SearchJob.vue";

export default {
  data() {
    return {
      opportunity: null,
    };
  },
  head() {
    return this.$head({
      title: "Vagas | ",
    });
  },

  components: {
    Jobs,
    SearchJob,
  },
};
</script>

<template>
  <div class="collection">
    <div class="container">
      <h1>Vagas em Lojas</h1>
      <p>
        Somos uma das maiores varejistas de moda alto padrão do Brasil.
        Atualmente, contamos com seis marcas: Le Lis Blanc, Bo.Bô, John John,
        Rosa Chá, Dudalina e Individual.
        <br />
        <br />
        Mas não somos apenas uma marca de roupas ou lojas. Muito mais que isso,
        somos um estilo de vida, uma experiência única, um sentimento de
        bem-estar, realização, felicidade, inspiração, beleza; um sonho bom.
        <br />
        <br />
        É através de nossos produtos, lojas e equipe que atingimos nosso
        objetivo. Somos um time de realizadores que concretizam o sonho dos
        nossos clientes.
      </p>
    </div>
  </div>
</template>


<style lang="scss" scoped>
.collection {
  margin-top: 4rem;
}
h1 {
  font-size: 1.9rem;
  text-transform: uppercase;
  font-weight: 500;
  color: #000;
}
p {
  font-size: 1.2rem;
  color: #000;
  margin-top: 1rem;
  border-bottom: 2px solid theme-color(primary);
  padding-bottom: 2rem;
  margin-bottom: 1.5rem;
}
</style>